import Buttons from "../../../components/UI/Buttons";
import SectionLoader from "../../../components/UI/SectionLoader";

const MissingClaim = (props) => {
    const { data, filter, isLoading } = props;
    const { missing_claim_numbers } = data || {};
    
    return (
        <>
            <div className="sh_cardBox sh_widgets sh_patientdetailwidget" >
                <div className="sh_cardHeader">
                    <div className="form-group d-flex mb-0 justify-content-between align-items-center">
                        <h6 className="text-md font-weight-bold mb-0">
                            <span className="px-2">
                                <Buttons
                                    iconType='DashboardClaim'
                                />
                            </span>
                            Missing Claim Numbers
                        </h6>
                    </div>
                </div>
                <div className="sh_cardBody py-0 dashboard_card">
                    <SectionLoader isLoading={isLoading}/>
                    <div className="row dashstatusbg-header my-0 py-0">
                        <div className="col-8  font-weight-bold"><a>Status</a></div>
                        <div className="col-4 font-weight-bold ratescount"><a>Count</a></div>
                    </div>
                    <div className="row dashstatusbg first">
                        <div className="col-8 px-0 font-weight-bold"><a>
                            <Buttons
                                iconType="redcircle"
                                className="px-2"
                            />
                            Total Missing Claims</a></div>
                        <div className="col-4 font-weight-bold ratescount"><a>{missing_claim_numbers?.total_missing_claims || 0}</a></div>
                    </div>
                    <div className="row dashstatusbg ">
                        <div className="col-8 px-0 font-weight-bold"><a>
                            <Buttons
                                iconType="bluecircle"
                                className="px-2"
                            />
                            Completed</a></div>
                        <div className="col-4 font-weight-bold ratescount"><a>{missing_claim_numbers?.completed || 0}</a></div>
                    </div>
                    <div className="row dashstatusbg first">
                        <div className="col-8 px-0 font-weight-bold"><a>
                            <Buttons
                                iconType="yellowcircle"
                                className="px-2"
                            />
                            Pending</a></div>
                        <div className="col-4 font-weight-bold ratescount"><a>{missing_claim_numbers?.pending || 0}</a></div>
                    </div>
                    <div className="row dashstatusbg">
                        <div className="col-8 px-0 font-weight-bold"><a>
                            <Buttons
                                iconType="redcircle"
                                className="px-2"
                            />
                            Failed</a></div>
                        <div className="col-4 font-weight-bold ratescount"><a>{missing_claim_numbers?.failed || 0}</a></div>
                    </div>
                </div>
                <div className="sh_cardFooter dashboardfooter border-0 pt-0 justify-content-center">
                    <Buttons className="btn dashboardbtn  btn-danger px-4" href={'/incident'} acl={'any'} >
                        Review ({missing_claim_numbers?.total_incidents || 0})
                    </Buttons>
                </div>
            </div>
        </>
    );
}
export default MissingClaim;